import React, { useState, Suspense } from "react"
import { useNavigate } from "react-router-dom"

import { Onboarding } from "../../../app/components/onboarding"
import OnboardingPage from "./components/onboarding-page"

import carBeach from "../../../assets/images/car-beach.svg"
import cleanInbox from "../../../assets/images/clean-inbox.svg"
import orderConfirmation from "../../../assets/images/order-confirmation.svg"
import webDev from "../../../assets/images/web-dev.svg"
import { Loading } from "@components/loading"

const slideProps = (handleClose: (ctaNumber: number) => void) => [
  {
    title: "Vehicle papers made easy",
    image: carBeach,
    alt: "Car driving on a beach",
    body: "Process online vehicle registration & car papers renewal that is easier, automated & with home/office delivery",
  },
  {
    title: "Get free, automated & multi-platform reminders",
    image: cleanInbox,
    alt: "hand holding phone with inbox",
    body: "Drive with peace of mind because you get free expiry reminders in App, by Whatsapp, Email & SMS",
  },
  {
    title: "Pay online with 100% money-back guarantee",
    image: orderConfirmation,
    alt: "Order confirmation",
    body: "You can easily see the cost of any vehcile papers & make payments with your card or make a bank transfer",
  },
  {
    title: "Ready to experience the ease of using CarPaddy?",
    image: webDev,
    alt: "A man unlocking door",
    ctas: [
      {
        color: "primary",
        variant: "contained",
        size: "large",
        text: "Sign up",
        fullWidth: true,
        onClick: () => handleClose(0),
      },
      {
        color: "primary",
        variant: "outlined",
        size: "large",
        text: "Log in",
        fullWidth: true,
        onClick: () => handleClose(1),
      },
    ],
    body: "",
  },
]

const FirstTimeOnboardingController = () => {
  const [show, setShow] = useState(true)
  const navigate = useNavigate()

  const handleClose = (ctaNumber: number) => {
    localStorage.setItem("seen-onb", JSON.stringify(true))
    ctaNumber === 0 ? navigate("/signup") : setShow(false)
  }

  const slides = slideProps(handleClose).map((slide) => {
    return { component: <OnboardingPage {...slide} /> }
  })

  return (
    <Suspense fallback={<Loading />}>
      {show ? <Onboarding slides={slides} /> : null}
    </Suspense>
  )
}

export default FirstTimeOnboardingController
